import React from "react";
import { Box, Chip, Typography } from "@mui/material";

interface IInternalBubbleProps {
  messageContent: string | null;
  createdAt: string;
}

export const InternalBubble: React.FC<IInternalBubbleProps> = ({
  messageContent,
  createdAt,
}) => {
  const formattedTime = new Date(createdAt).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
  });

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mb: 1.5,
        px: 1,
      }}
    >
      <Box
        sx={{
          backgroundColor: "grey.200",
          borderRadius: "7.5px",
          p: 1.5,
          maxWidth: { xs: "85%", sm: "65%" },
          width: "fit-content",
        }}
      >
        <Chip
          label="Not sent to customer"
          size="small"
          sx={{
            mb: 1,
            fontSize: "0.7rem",
            height: 20,
            backgroundColor: "grey.400",
            color: "white",
          }}
        />
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {messageContent || "No reasoning provided"}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            display: "block",
            mt: 0.5,
            color: "text.disabled",
            textAlign: "right",
            fontSize: "0.6875rem",
          }}
        >
          {formattedTime}
        </Typography>
      </Box>
    </Box>
  );
};
